<template>
	<div>
		<div class="seckill">
			<div class="seckill-l">
				<div class="seckill-l-top">
					<div class="seckill-title">整点秒杀</div>
					<div class="seckill-time">下一场倒计时</div>
					<div class="seckill-num">
						<span>08</span>
						<span>16</span>
						<span>12</span>
					</div>
					<ul class="seckill-tab">
						<li>14:00场-即将开抢</li>
						<li class="active">14:00场-即将开抢</li>
						<li>更多</li>
					</ul>
				</div>
				<div class="seckill-list">
					<div class="seckill-item">
						<img class="seckill-item-img" src="../../../assets/shop_img/1.png" alt />
						<div class="seckill-item-name">浪莎LangSha男士纯棉浪莎LangSha男士纯棉…</div>
						<div class="seckill-item-pic">
							<span>￥120.00</span>
							<span>￥380.00</span>
						</div>
					</div>
					<div class="seckill-item">
						<img class="seckill-item-img" src="../../../assets/shop_img/2.png" alt />
						<div class="seckill-item-name">浪莎LangSha男士纯棉浪莎LangSha男士纯棉…</div>
						<div class="seckill-item-pic">
							<span>￥120.00</span>
							<span>￥380.00</span>
						</div>
					</div>
					<div class="seckill-item">
						<img class="seckill-item-img" src="../../../assets/shop_img/3.png" alt />
						<div class="seckill-item-name">浪莎LangSha男士纯棉浪莎LangSha男士纯棉…</div>
						<div class="seckill-item-pic">
							<span>￥120.00</span>
							<span>￥380.00</span>
						</div>
					</div>
					<div class="seckill-item">
						<img class="seckill-item-img" src="../../../assets/shop_img/4.png" alt />
						<div class="seckill-item-name">浪莎LangSha男士纯棉浪莎LangSha男士纯棉…</div>
						<div class="seckill-item-pic">
							<span>￥120.00</span>
							<span>￥380.00</span>
						</div>
					</div>
					<div class="seckill-item">
						<img class="seckill-item-img" src="../../../assets/shop_img/5.png" alt />
						<div class="seckill-item-name">浪莎LangSha男士纯棉浪莎LangSha男士纯棉…</div>
						<div class="seckill-item-pic">
							<span>￥120.00</span>
							<span>￥380.00</span>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		}
	};
</script>
<style lang="scss" scoped>
	// 秒杀
	.seckill {
		width: 100%;
		height: 295px;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;

		.seckill-l {
			display: flex;
			flex-direction: column;
			width: 890px;
			height: 295px;
			background-color: #fff;
			padding: 0 20px;
			box-sizing: border-box;

			.seckill-l-top {
				height: 52px;
				display: flex;
				align-items: flex-end;
				border-bottom: 1px solid #ebebeb;
				padding-bottom: 8px;
				box-sizing: border-box;

				.seckill-title {
					color: #ff0e25;
					font-size: 18px;
					font-weight: 600;
				}

				.seckill-time {
					margin-left: 20px;
				}

				.seckill-num {
					margin-left: 12px;
					display: flex;

					span {
						width: 20px;
						height: 24px;
						background: #333333;
						border-radius: 4px;
						color: #ffffff;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-right: 8px;
					}
				}

				.seckill-tab {
					margin-left: auto;
					display: flex;
					align-items: center;

					li+li {
						margin-left: 40px;
					}

					.active {
						color: #fff;
						width: 113px;
						height: 24px;
						background: linear-gradient(270deg,
							rgba(255, 14, 37, 1) 0%,
							rgba(255, 144, 16, 1) 100%);
						border-radius: 12px;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}
			}

			.seckill-list {
				// height: 100%;
				flex: 1;
				padding: 20px 0;
				box-sizing: border-box;
				display: flex;

				.seckill-item {
					width: 20%;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: center;

					&:hover {
						opacity: 0.8;
						color: #c81623;
					}

					&:hover .seckill-item-name {
						color: #c81623;
					}

					.seckill-item-img {
						height: 136px;
						width: 136px;
					}

					.seckill-item-name {
						width: 133px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.seckill-item-pic {
						width: 150px;
						height: 24px;
						background-image: url("../../../assets/images/pic.png");
						background-repeat: no-repeat;
						display: flex;
						justify-content: space-around;
						align-items: center;

						:first-child {
							font-size: 16px;
							color: #fff;
						}

						:last-child {
							color: #999999;
						}
					}
				}
			}
		}
	}
</style>
